import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../Buttons';
import { CodeRefusal } from '../CodeInput';

import { SendError } from './CodeStepActions';
import type { CodeStepHalt } from './codeStepStatus';
import { fillOnPhoneSx, haltedSx, startSx } from './codeStepStyles';

export interface HaltedStepProps {
  readonly status: CodeStepHalt;
  readonly resending: boolean;
  readonly sendError: string | null;
  readonly change: React.ReactElement;
  readonly onResend: () => void;
}

export const HaltedStep: React.FC<HaltedStepProps> = ({ status, resending, sendError, change, onResend }) => {
  const { t } = useTranslation();
  const message = status.kind === 'expired' ? t('coreComponents.codeStep.expired', 'Code expired. Send a new one.') : status.message;
  return (
    <Box sx={haltedSx}>
      <CodeRefusal message={message} />
      {status.kind === 'expired' && (
        <Button type="button" intent="primary" busy={resending} autoFocus onClick={onResend} sx={fillOnPhoneSx}>
          {t('coreComponents.codeInput.resend', 'Send a new code')}
        </Button>
      )}
      <SendError message={sendError} />
      <Box sx={startSx}>{change}</Box>
    </Box>
  );
};
